import { Star, Quote } from "lucide-react";

const REVIEWS = [
  { name: "Camila R.", city: "General Carneiro", text: "Chamei no grupo e em 3 minutos tava lá. Preço honesto, motorista educado. Virei cliente.", stars: 5 },
  { name: "Carlos M.", city: "Vila Vitória", text: "Melhor que qualquer app. Conheço o motorista e ele conhece minha rotina. Recomendo muito.", stars: 5 },
  { name: "Juliana S.", city: "Roças Novas", text: "Usei de madrugada pra trabalhar. Chegou rápido e seguro. Troy salvou meu dia.", stars: 5 },
  { name: "Rodrigo P.", city: "Morada da Serra", text: "Atendimento rápido, carro limpo, preço justo. Já cadastrei minha esposa também.", stars: 5 },
  { name: "Paula T.", city: "Borges", text: "Preço sem dinâmica, atendimento humano. É isso que faz diferença na correria.", stars: 5 },
  { name: "Marcos L.", city: "Esplanada", text: "Uso toda semana pro trabalho. Pontualidade 10/10.", stars: 5 },
  { name: "Beatriz F.", city: "Siderúrgica", text: "Recomendo de olhos fechados. Muito mais barato e rápido que outros apps. E ainda ganhei brinde do sorteio!", stars: 5 },
  { name: "Anderson D.", city: "General Carneiro", text: "Motorista simpático, viagem tranquila. Voltarei com certeza.", stars: 5 },
];

export default function Testimonials() {
  const track = [...REVIEWS, ...REVIEWS];
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-12 flex items-end justify-between flex-wrap gap-6">
        <div>
          <p className="text-xs tracking-[0.25em] uppercase text-[#FFCC00] font-bold mb-3">
            Provas sociais
          </p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-tight">
            Mais de <span className="text-[#FFCC00]">1000 passageiros</span>{" "}
            atendidos.
          </h2>
        </div>
        <div className="flex items-center gap-3 px-5 py-3 rounded-full bg-[#18181C] border border-[#FFCC00]/15">
          <div className="flex">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-[#FFCC00] text-[#FFCC00]" />
            ))}
          </div>
          <span className="text-sm text-white/80 font-semibold">4.9/5.0</span>
        </div>
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-[#08080A] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-[#08080A] to-transparent z-10 pointer-events-none" />
        <div className="marquee-track gap-5 pl-5">
          {track.map((r, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="w-[320px] sm:w-[380px] flex-shrink-0 rounded-3xl p-6 md:p-7 bg-[#18181C] border border-[#FFCC00]/15 hover:border-[#FFCC00]/40 transition-colors"
            >
              <Quote className="w-6 h-6 text-[#FFCC00] mb-3" />
              <p className="text-white/85 leading-relaxed">"{r.text}"</p>
              <div className="mt-5 pt-5 border-t border-white/10 flex items-center justify-between">
                <div>
                  <p className="font-bold">{r.name}</p>
                  <p className="text-xs text-white/50">{r.city}</p>
                </div>
                <div className="flex">
                  {Array.from({ length: r.stars }).map((_, k) => (
                    <Star key={k} className="w-3.5 h-3.5 fill-[#FFCC00] text-[#FFCC00]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
